import { defineComponent, h } from 'vue';
import { t } from '@/ui/i18n/i18n';

export const Geolocation = defineComponent({
  name: 'Geolocation',
  props: ['item'],
  setup(props) {
    return function render() {
      const getLocation = () => {
        return h('a', {
          class: 'inspection-report__link',
          attrs: {
            target: '__blank',
            href: `${process.env.VUE_APP_GOOGLE_MAPS_LINK}?q=${props.item.response.lat},${props.item.response.long}`,
          },
        },
        props.item.response.address
          ? `${props.item.response.address} (${props.item.response.lat}, ${props.item.response.long})`
          : `${props.item.response.lat}, ${props.item.response.long}`);
      };

      return h('div', [
        props.item.responded ? getLocation() : t('inspections.location-not-set'),
      ]);
    };
  },
});
